var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "privew",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 45,
    height: 45,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(-64 -319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(74 329)",
    fill: "#e62237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M10.363,3a9.338,9.338,0,0,1,9.181,7.638,9.337,9.337,0,0,1-18.363,0A9.338,9.338,0,0,1,10.363,3Zm0,13.579a7.642,7.642,0,0,0,7.449-5.941,7.641,7.641,0,0,0-14.9,0A7.642,7.642,0,0,0,10.363,16.579Zm0-2.122a3.819,3.819,0,1,1,3.819-3.819A3.819,3.819,0,0,1,10.363,14.457Zm0-1.7a2.122,2.122,0,1,0-2.122-2.122A2.122,2.122,0,0,0,10.363,12.76Z",
    transform: "translate(76.456 331.362)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivew);
export default __webpack_public_path__ + "static/media/privew.97e9626c15c0b1f43ca6756bdb340754.svg";
export { ForwardRef as ReactComponent };